module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "180px"
    }
  }, [_c('p', [_vm._v("Although the village of Imber, now a")]), _vm._v(" "), _c('p', [_vm._v("practice range for the British Army,")]), _vm._v(" "), _c('p', [_vm._v("on Salisbury Plain, gave me he idea for")]), _vm._v(" "), _c('p', [_vm._v("this novel. The characters and events in")]), _vm._v(" "), _c('p', [_vm._v("it are entirely fictitious.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "13em"
    }
  }, [_c('strong', [_vm._v("C.H.C.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda61350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 78
// module chunks = 0